<html>
<head>
<style>
  @media print {
    @page {
      size: 80mm auto;
      margin: 0;
    }
    html, body {
      background: #fff !important;
      padding: 0 !important;
      width: 80mm;
    }
    .ticket-wrap {
      display: block !important;
      min-height: 0 !important;
      padding: 0 !important;
      width: auto !important;
    }
    .ticket-outer {
      width: 100% !important;
      background: #fff !important;
      padding: 0 !important;
      border-radius: 0 !important;
    }
  }

  * {
    box-sizing: border-box;
  }

  html, body {
    margin: 0;
    background: #e4e2e0;
    font-family: system-ui, sans-serif;
  }

  .ticket-wrap {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 48px;
  }

  .ticket-outer {
    width: 320px;
    background: #e4e2e0;
    padding: 24px;
    border-radius: 4px;
  }
</style>
</head>
<body>

<div class="ticket-wrap">
  <div class="ticket-outer">
    <app-ticket-receipt [ticket]="ticket" [details]="ticketDetails" [company]="company" [office]="office"
      [hidePrices]="hidePrices"></app-ticket-receipt>
  </div>
</div>

</body>
</html>
